import {ContentFilters, ContentTopBar } from 'components';
import { useState } from 'react';
import { CompanyType } from 'types';

import { EntryLogFilterFormValues } from './type';
import { VehicleFilterForm } from './vehicle-filter-form';

type MatrialTopBarProps = {
  getInitialFilterValues: EntryLogFilterFormValues;
  handleFilter: (values: EntryLogFilterFormValues) => void;
  userEditData: any;
  showAppUserModal:any;
  setShowAppUserModal:any
  onRefresh: () => void;
};

export const VehicleUpLoadingLogTopBar = ({
  getInitialFilterValues,
  handleFilter,
  onRefresh
}: MatrialTopBarProps) => {
  useState<CompanyType>();
  const formId = 'end-users-filters-form';
  
return (
    <>
      <ContentTopBar title={'Uploading Vehicle'}/>
      <ContentFilters formId={formId}>
        <VehicleFilterForm
          formId={formId}
          handleFilter={handleFilter}
          initialValues={getInitialFilterValues}
          onRefresh={onRefresh}
        />
      </ContentFilters>
    </>
  );
};
